export const getInjects = (props: Record<string, ANY>, inject: (key: string, _: ANY) => string): Record<string, ANY> => {
    const out: Record<string, ANY> = {}
    Object.keys(props).forEach((key) => {
        out[key] = inject(key, undefined)
    })
    return out
}
